(() => {
  const NativeAudioContext = window.AudioContext || window.webkitAudioContext;
  if (!NativeAudioContext || window.__wardenDeepMobileAudioUnlockInstalled) return;
  window.__wardenDeepMobileAudioUnlockInstalled = true;

  let sharedContext = null;
  let mediaPrimer = null;
  let mediaPrimerUrl = null;
  let warmOscillator = null;
  let warmGain = null;
  let warmStopTimer = 0;
  let routeUnlocked = false;
  let primingNow = false;

  function getSharedContext(...args) {
    if (!sharedContext || sharedContext.state === 'closed') {
      try { sharedContext = new NativeAudioContext(...args); }
      catch (_) { sharedContext = new NativeAudioContext(); }
    }
    return sharedContext;
  }

  function SharedAudioContext(...args) { return getSharedContext(...args); }
  try {
    SharedAudioContext.prototype = NativeAudioContext.prototype;
    Object.setPrototypeOf(SharedAudioContext, NativeAudioContext);
  } catch (_) {}
  if (window.AudioContext) window.AudioContext = SharedAudioContext;
  if (window.webkitAudioContext) window.webkitAudioContext = SharedAudioContext;

  function buildPrimerWavUrl() {
    const sampleRate = 8000, durationSeconds = 0.12, samples = Math.floor(sampleRate * durationSeconds), bytesPerSample = 2, dataSize = samples * bytesPerSample;
    const buffer = new ArrayBuffer(44 + dataSize), view = new DataView(buffer);
    let offset = 0;
    const writeText = text => { for (let i = 0; i < text.length; i += 1) view.setUint8(offset++, text.charCodeAt(i)); };
    writeText('RIFF'); view.setUint32(offset, 36 + dataSize, true); offset += 4;
    writeText('WAVE'); writeText('fmt '); view.setUint32(offset, 16, true); offset += 4;
    view.setUint16(offset, 1, true); offset += 2; view.setUint16(offset, 1, true); offset += 2;
    view.setUint32(offset, sampleRate, true); offset += 4; view.setUint32(offset, sampleRate * bytesPerSample, true); offset += 4;
    view.setUint16(offset, bytesPerSample, true); offset += 2; view.setUint16(offset, 16, true); offset += 2;
    writeText('data'); view.setUint32(offset, dataSize, true); offset += 4;
    for (let i = 0; i < samples; i += 1) { view.setInt16(offset, (i % 8 < 4) ? 1 : -1, true); offset += 2; }
    return URL.createObjectURL(new Blob([buffer], { type: 'audio/wav' }));
  }

  function ensureMediaPrimer() {
    if (mediaPrimer) return mediaPrimer;
    mediaPrimerUrl = buildPrimerWavUrl();
    const audio = document.createElement('audio');
    audio.preload = 'auto'; audio.setAttribute('playsinline', ''); audio.setAttribute('webkit-playsinline', '');
    audio.volume = 1; audio.muted = false; audio.src = mediaPrimerUrl;
    audio.style.position = 'fixed'; audio.style.width = '1px'; audio.style.height = '1px'; audio.style.opacity = '0'; audio.style.pointerEvents = 'none'; audio.style.left = '-9999px';
    document.body.appendChild(audio); mediaPrimer = audio; return audio;
  }

  function sliderToFrequency(position) {
    const p = Math.max(0, Math.min(1000, Number(position) || 0));
    return Math.max(1, Math.min(1000, Math.pow(1000, p / 1000)));
  }

  function requestedFrequency(button) {
    const lab = button.closest('[data-bps-lab]'); if (!lab) return 20;
    const selector = button.matches('[data-bps-start-sweep]') ? '[data-bps-sweep-start]' : '[data-bps-range]';
    const range = lab.querySelector(selector); return range ? sliderToFrequency(range.value) : 20;
  }

  function stopWarmOscillator() {
    clearTimeout(warmStopTimer); warmStopTimer = 0;
    const osc = warmOscillator, gain = warmGain; warmOscillator = null; warmGain = null;
    if (sharedContext && gain) { try { gain.gain.cancelScheduledValues(sharedContext.currentTime); gain.gain.setValueAtTime(0, sharedContext.currentTime); } catch (_) {} }
    if (osc) { try { osc.stop(); } catch (_) {} try { osc.disconnect(); } catch (_) {} }
    if (gain) { try { gain.disconnect(); } catch (_) {} }
  }

  function primeHtmlMediaRoute() {
    const audio = ensureMediaPrimer();
    try {
      audio.currentTime = 0;
      const playPromise = audio.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => {
          routeUnlocked = true;
          if (sharedContext && sharedContext.state === 'suspended') {
            try { const resumePromise = sharedContext.resume(); if (resumePromise && resumePromise.catch) resumePromise.catch(() => {}); } catch (_) {}
          }
        }).catch(() => {});
      }
    } catch (_) {}
  }

  function startWarmOscillator(frequency) {
    stopWarmOscillator();
    const ctx = getSharedContext({ latencyHint: 'interactive' });
    const osc = ctx.createOscillator(), gain = ctx.createGain();
    osc.type = 'square'; osc.frequency.setValueAtTime(Math.max(1, Math.min(1000, frequency)), ctx.currentTime); gain.gain.setValueAtTime(1, ctx.currentTime);
    osc.connect(gain); gain.connect(ctx.destination); warmOscillator = osc; warmGain = gain;
    osc.start(ctx.currentTime);
    try { if (ctx.state === 'suspended') { const resumePromise = ctx.resume(); if (resumePromise && resumePromise.catch) resumePromise.catch(() => {}); } } catch (_) {}
    warmStopTimer = window.setTimeout(stopWarmOscillator, 900);
  }

  function primeFromRealClick(event) {
    const button = event.target && event.target.closest ? event.target.closest('[data-bps-start-tone],[data-bps-start-sweep]') : null;
    if (!button || routeUnlocked || primingNow) return;
    primingNow = true;
    try { primeHtmlMediaRoute(); startWarmOscillator(requestedFrequency(button)); } catch (_) {}
    window.setTimeout(() => { primingNow = false; }, 120);
  }

  document.addEventListener('click', primeFromRealClick, { capture: true });
  window.addEventListener('warden:squareMusic', event => {
    const name = event.detail && event.detail.event;
    if (name === 'bps_tone_start' || name === 'bps_pingpong_start' || name === 'bps_resume') { window.setTimeout(stopWarmOscillator, 40); routeUnlocked = true; }
    if (name === 'bps_pause' || name === 'bps_stop' || name === 'play') stopWarmOscillator();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stopWarmOscillator(); });
  window.addEventListener('pagehide', () => {
    stopWarmOscillator();
    if (mediaPrimerUrl) { try { URL.revokeObjectURL(mediaPrimerUrl); } catch (_) {} mediaPrimerUrl = null; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { try { ensureMediaPrimer(); } catch (_) {} }, { once: true });
  else { try { ensureMediaPrimer(); } catch (_) {} }
})();
